import { obterGrupoEquipamentoAsync } from "../../services/grupoEquipamentoService";

const atualizarGrupoEquipamentos = async ({ commit }) => {
    const grupoEquipamentos = await obterGrupoEquipamentoAsync();
    commit('atualizarGrupoEquipamentos', grupoEquipamentos);
}

const atualizarGrupoEquipamento = ({ commit }, grupoEquipamentos) => {
    commit('atualizarGrupoEquipamento', grupoEquipamentos);
}

export default {
    atualizarGrupoEquipamentos,
    atualizarGrupoEquipamento
}